// extracted by mini-css-extract-plugin
module.exports = {"button":"buttonNew_button__1ZTzA","normal":"buttonNew_normal__3SuMw","primary":"buttonNew_primary__35hda","secondary":"buttonNew_secondary__3XjdM"};